/* Native disclosures remain usable without JS. Motion never delays their state. */
(() => {
  if (window.smCarePagesInstalled) return;
  window.smCarePagesInstalled = true;
  const instances = new WeakMap();
  const init = root => root.querySelectorAll?.('.bb-about,.bb-support,.bb-returns').forEach(page => {
    if (instances.has(page) || page.matches('.bb-support')) return;
    const controller = new AbortController();
    const animations = new Map();
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    page.querySelectorAll('details').forEach(disclosure => {
      const body = disclosure.querySelector('.bb-support__faq-answer,.bb-returns__faq-answer,.bb-returns__policy-body');
      if (!body) return;
      disclosure.addEventListener('toggle', () => {
        animations.get(body)?.cancel();
        animations.delete(body);
        if (!disclosure.open || reduced.matches || !body.animate) return;
        const animation = body.animate([{ opacity:.65 },{ opacity:1 }], { duration:150, easing:'ease-out' });
        animations.set(body, animation);
        animation.finished.then(() => { if (animations.get(body) === animation) animations.delete(body); }).catch(() => {});
      }, { signal:controller.signal });
    });
    reduced.addEventListener('change', () => { if (reduced.matches) { animations.forEach(animation => animation.cancel()); animations.clear(); } }, { signal:controller.signal });
    instances.set(page, () => { controller.abort(); animations.forEach(animation => animation.cancel()); instances.delete(page); });
  });
  const unload = root => root.querySelectorAll?.('.bb-about,.bb-support,.bb-returns').forEach(page => instances.get(page)?.());
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => unload(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once:true });
  else init(document);
})();
